import React from 'react';
import { APP_VERSION } from '@/lib/version';

export function VersionBadge() {
  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-black tracking-widest uppercase bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 border border-slate-200 dark:border-slate-700 select-none">
      {APP_VERSION}
    </span>
  );
}